import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ShoppingCart } from 'lucide-react';

const LOGO_URL =
  'https://customer-assets-rejwkqb3.emergentagent.net/job_6105b58a-7e55-474e-a974-617e58e42c4a/artifacts/q23o4nye_Gemini_Generated_Image_487caf487caf487c.png';

const GOLD = '#C9A84C';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const links = [
    { to: '/', label: 'Inicio' },
    { to: '/caracteristicas', label: 'Características' },
    { to: '/distribuidores', label: 'Distribuidores' },
    { to: '/mixologia', label: 'Mixología' },
    { to: '/contacto', label: 'Contacto' },
  ];

  return (
    <nav
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 50,
        background: scrolled ? 'rgba(0,0,0,0.96)' : 'transparent',
        backdropFilter: scrolled ? 'blur(12px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(201,168,76,0.18)' : 'none',
        padding: scrolled ? '0.75rem 0' : '1.5rem 0',
        transition: 'background 0.4s ease, padding 0.4s ease, border-bottom 0.4s ease',
        fontFamily: 'Montserrat, sans-serif',
      }}
    >
      <div
        style={{
          maxWidth: '80rem',
          margin: '0 auto',
          padding: '0 1.5rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Logo */}
        <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', textDecoration: 'none' }}>
          <img
            src={LOGO_URL}
            alt="Aura"
            style={{
              width: '2.5rem',
              height: '2.5rem',
              borderRadius: '50%',
              objectFit: 'cover',
            }}
          />
          <div style={{ display: 'none', lineHeight: 1 }} className="sm:block">
            <div
              style={{
                color: GOLD,
                fontFamily: 'Cormorant Garamond, serif',
                fontSize: '1.15rem',
                fontWeight: 600,
                letterSpacing: '0.3em',
              }}
            >
              AURA
            </div>
            <div
              style={{
                color: 'rgba(201,168,76,0.5)',
                fontSize: '0.6rem',
                letterSpacing: '0.3em',
                textTransform: 'uppercase',
              }}
            >
              KING &amp; QUEEN
            </div>
          </div>
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex" style={{ gap: '2.5rem', alignItems: 'center' }}>
          {links.map(({ to, label }) => {
            const active = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                style={{
                  color: active ? GOLD : 'rgba(255,255,255,0.65)',
                  textDecoration: 'none',
                  fontSize: '0.72rem',
                  letterSpacing: '0.25em',
                  textTransform: 'uppercase',
                  borderBottom: active ? `1px solid ${GOLD}` : 'none',
                  paddingBottom: active ? '2px' : '0',
                  transition: 'color 0.3s ease',
                }}
                onMouseEnter={(e) => !active && (e.target.style.color = GOLD)}
                onMouseLeave={(e) => !active && (e.target.style.color = 'rgba(255,255,255,0.65)')}
              >
                {label}
              </Link>
            );
          })}
        </div>

        {/* CTA */}
        <div className="hidden md:flex">
          <Link
            to="/distribuidores"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.6rem 1.5rem',
              background: GOLD,
              color: '#000',
              fontSize: '0.7rem',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              fontWeight: 600,
              textDecoration: 'none',
              transition: 'opacity 0.3s ease',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.opacity = '0.82')}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = '1')}
          >
            <ShoppingCart size={13} />
            ¿Dónde Comprar?
          </Link>
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className="md:hidden"
          style={{ color: GOLD, background: 'none', border: 'none', cursor: 'pointer' }}
        >
          {menuOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div
          style={{
            background: 'rgba(0,0,0,0.98)',
            borderTop: '1px solid rgba(201,168,76,0.15)',
            padding: '1.5rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.25rem',
          }}
          className="md:hidden"
        >
          {links.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              style={{
                color: location.pathname === to ? GOLD : 'rgba(255,255,255,0.65)',
                textDecoration: 'none',
                fontSize: '0.72rem',
                letterSpacing: '0.25em',
                textTransform: 'uppercase',
              }}
            >
              {label}
            </Link>
          ))}
          <Link
            to="/distribuidores"
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              padding: '0.85rem',
              background: GOLD,
              color: '#000',
              fontSize: '0.7rem',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
              fontWeight: 600,
              textDecoration: 'none',
              width: '100%',
            }}
          >
            <ShoppingCart size={13} />
            ¿Dónde Comprar?
          </Link>
        </div>
      )}
    </nav>
  );
}
